export enum AudienceSourceType {
  Unspecified = 'AUDIENCE_SOURCE_TYPE_UNSPECIFIED',
  Segment = 'AUDIENCE_SOURCE_TYPE_SEGMENT',
  Table = 'AUDIENCE_SOURCE_TYPE_TABLE',
}

export enum ContentConfigStatus {
  Unspecified = 'CONTENT_CONFIG_STATUS_UNSPECIFIED',
  Active = 'CONTENT_CONFIG_STATUS_ACTIVE',
  PendingApproval = 'CONTENT_CONFIG_STATUS_PENDING_APPROVAL',
  Rejected = 'CONTENT_CONFIG_STATUS_REJECTED',
  Recalled = 'CONTENT_CONFIG_STATUS_RECALLED',
}

export type EpochSeconds = string | number;

export interface AudiencePersonaVariable {
  name: string;
  description: string;
}

export interface AudienceDeeplink {
  names: string[];
  deepLinkTemplate: string;
}

export interface AudienceFormValue {
  country: string;
  deeplink: AudienceDeeplink;
  description: string;
  isDraft: boolean;
  name: string;
  personaVariables: AudiencePersonaVariable[];
  source: string;
  type?: AudienceSourceType;
}

export interface AudienceValidationErrors {
  country?: string;
  deepLinkTemplate?: string;
  deeplinkNames?: string;
  description?: string;
  name?: string;
  personaVariableDescriptions?: Record<string, string | undefined>;
  personaVariables?: string;
  source?: string;
  type?: string;
}

export interface AudienceColumnOption {
  key: string;
  desc: string;
}

export interface AudienceTableInfoState {
  columns?: string[];
  error?: {
    message?: string;
    status?: number;
  } | null;
  isLoading?: boolean;
}

export interface ContentConfigMetaApi {
  id: string;
  entity: string;
  country: string;
  key: string;
  status: ContentConfigStatus;
  expires_at?: EpochSeconds;
  created_at?: EpochSeconds;
  updated_at?: EpochSeconds;
  created_by?: string;
  updated_by?: string;
  reviewed_at?: EpochSeconds;
  reviewed_by?: string;
  review_comment?: string;
}

export type AudiencePersonaVariableApi = AudiencePersonaVariable;

export interface AudienceDeeplinkApi {
  names: string[];
  deep_link_template: string;
}

export interface AudienceBodyApi {
  type: AudienceSourceType;
  name: string;
  description: string;
  source: string;
  persona_variables?: AudiencePersonaVariableApi[];
  deeplink?: AudienceDeeplinkApi;
}

export interface AudienceConfigApi {
  meta: ContentConfigMetaApi;
  body: AudienceBodyApi;
}

export interface ListAudiencesResponseApi {
  configs?: AudienceConfigApi[];
  next_page_token?: string;
}

export interface AudienceTableInfoResponseApi {
  columns?: string[];
}

export interface ProductLangConfigApi {
  name: string;
  ci_enabled: boolean;
  product_overview: string;
  reason_to_use: string;
  call_to_action: string[];
}

export interface ProductAudienceAssociationApi {
  audience_key: string;
  reason_to_use?: string;
}

export interface ProductBodyApi {
  name: string;
  vertical: string;
  config_by_lang: Record<string, ProductLangConfigApi>;
  cvps?: string[];
  attributes?: string[];
  personas?: string[];
  audiences?: ProductAudienceAssociationApi[];
}

export interface ProductAudienceAssociation {
  audienceKey: string;
  reasonToUse: string;
}

export interface AudienceReference {
  key: string;
  name: string;
  country: string;
  sourceType: AudienceSourceType;
  status: ContentConfigStatus;
}

export interface ProductAudienceOption extends AudienceReference {
  eligible: boolean;
  label: string;
  unavailableReason: string;
}
